<section class="m-lg !p-lg !gap-md overflow-y-auto bg-white" hlmCard>
  <div hlmCardHeader>
    <h3 hlmCardTitle>Panneau d'administration</h3>
    <div hlmCardAction>
      <hlm-select
        class="inline-block"
        (valueChange)="setCartographieCourante($event)"
        placeholder="Sélectionnez une cartographie"
      >
        <hlm-select-trigger class="w-max">
          {{ cartographie()?.nom || 'Sélectionnez une cartographie' }}
        </hlm-select-trigger>
        <hlm-select-content>
          @for (cartographie of cartographies() | trierPar: 'nom'; track cartographie.id) {
            <hlm-option [value]="cartographie">{{ cartographie.nom }}</hlm-option>
          }
        </hlm-select-content>
      </hlm-select>
    </div>
  </div>
  <div class="!p-0" hlmCardContent>
    <div class="gap-md grid grid-cols-3">
      <app-card-etape-carto
        (action)="navigateTo('gestion')"
        texte="Administrer les cartographies"
        icone="lucideUserStar"
      />
      <app-card-etape-carto
        [disabled]="!cartographie()"
        (action)="navigateTo('référentiels')"
        texte="Liste des référentiels"
        icone="lucideNotebookText"
      />
      <app-card-etape-carto
        [disabled]="!cartographie()"
        (action)="navigateTo('parcours')"
        texte="Liste des parcours"
        icone="lucideRoute"
      />
      <app-card-etape-carto
        [disabled]="!cartographie()"
        (action)="navigateTo('formations-obligatoires-réglementaires')"
        texte="Liste des formations obligatoires réglementaires"
        icone="lucideBookMarked"
      />
      <app-card-etape-carto
        [disabled]="!cartographie()"
        [loadingState]="isLoading()"
        (action)="exportCartographie()"
        texte="Export de la cartographie"
        icone="lucideLandPlot"
      />
      <app-card-etape-carto
        [disabled]="!cartographie()"
        (action)="navigateTo('modalités')"
        texte="Liste des modalités"
        icone="lucideSchool"
      />
      <app-card-etape-carto
        (action)="navigateTo('techniques-animation')"
        texte="Liste des techniques d'animation"
        icone="lucideLandPlot"
      />
      <app-card-etape-carto
        (action)="navigateTo('certifications')"
        texte="Liste des certifications"
        icone="lucideBadgeCheck"
      />
      <app-card-etape-carto
        (action)="navigateTo('trigrammes-type-certification')"
        texte="Liste des trigrammes type des certifications"
        icone="lucideBookType"
      />
      <app-card-etape-carto
        (action)="navigateTo('messages-information')"
        texte="Messages d'information"
        icone="lucideMegaphone"
      />
    </div>
  </div>
</section>
